import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Session from '../services/session';
import type ShareIntentService from '../services/share-intent';

export default class LoginRoute extends Route {
  @service declare session: Session;
  @service declare router: RouterService;
  @service declare shareIntent: ShareIntentService;

  beforeModel() {
    if (this.session.isAuthenticated) {
      const redirect = localStorage.getItem('favoris:login-redirect');
      if (redirect) {
        localStorage.removeItem('favoris:login-redirect');
        this.router.transitionTo(redirect);
      } else if (
        this.shareIntent.pendingUrl ||
        this.shareIntent.pendingImageUri
      ) {
        this.router.transitionTo('extract');
      } else {
        this.router.transitionTo('index');
      }
    }
  }
}
